import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import State from "../../../../../context";
import Cookies from "js-cookie";
import { Button, ConfigProvider, Flex, Layout, theme } from "antd";
import MenuActions from "../../../../../atom/MenuActions";
import MenuSidebar from "../../../../../atom/MenuSidebar";
import ModalConversationDetails from "../component/ModalConversationDetails";
import ModalManagerSettings from "../../../../oneascent/tenant/admin/component/ModalManagerSettings";
import SectionAskAdvice from "../../../../../organism/SectionAskAdvice";

import { ReactComponent as Logo } from "../image/logo.svg";
import { ReactComponent as PennyAi } from "../image/icon_penny.svg";
import { ReactComponent as SidebarCompanies } from "./image/companies.svg";
import { ReactComponent as SidebarPenny } from "./image/penny.svg";
import { ReactComponent as SidebarProducts } from "./image/products.svg";
import { ReactComponent as SidebarUsers } from "./image/users.svg";
import { ReactComponent as Profile } from "../../../../../image/icon/profile.svg";

const TemplateSuperAdminAuthorized = ({ children }) => {
  const [state, setState] = useContext(State);
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const sidebarItems = [
    {
      Icon: SidebarCompanies,
      label: "Companies",
      path: "/super-admin/companies",
      visible: true,
    },
    {
      Icon: SidebarUsers,
      label: "Users",
      path: "/super-admin/users",
      visible: true,
    },
    {
      Icon: SidebarProducts,
      label: "Products",
      path: "/super-admin/products",
      visible: true,
    },
    {
      Icon: SidebarPenny,
      label: "Penny",
      path: "/super-admin/conversations",
      visible: true,
    },
  ];

  const MenuProfile = () =>
    state.personalInfo && (
      <MenuActions
        items={[
          {
            key: "logOut",
            label: "Log-out",
            onClick: () => {
              Cookies.remove(`jwt__${decodeURIComponent(state._id)}`);
              navigate("/login");
            },
          },
        ]}
      >
        <Flex
          align="center"
          gap={12}
          style={{
            color: token.sidebar_profile_color,
            cursor: "pointer",
            padding: token.sidebar_menu_item_padding,
            textTransform: "capitalize",
            width: "100%",
          }}
        >
          <Profile />
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {`${state.personalInfo.firstName[0]}. ${state.personalInfo.lastName}`}
          </span>
        </Flex>
      </MenuActions>
    );

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            activeBarBorderWidth: 0,
            itemSelectedBg: token.colorPrimary,
            itemSelectedColor: "#fff",
            itemHoverBg: token.colorPrimary,
            itemHoverColor: "#fff",
          },
        },
      }}
    >
      <Layout>
        <Layout.Header
          style={{
            background: "#fff",
            borderBottom: "1px solid #DADEE5",
            padding: "0 24px",
          }}
        >
          <Flex
            align="center"
            justify="space-between"
            style={{ height: "100%" }}
          >
            <Logo />
            <Button
              disabled={!state.features?.penny}
              icon={<PennyAi />}
              onClick={() => state.setKeyValue("openModalAskAdvice", true)}
              shape="round"
              style={{ background: "#E6F4EF" }}
              type="text"
            >
              <span>
                Ask<b>Penny</b>
              </span>
            </Button>
          </Flex>
        </Layout.Header>

        <Layout style={{ height: "calc(100vh - 64px)" }}>
          <Layout.Sider
            breakpoint="md"
            collapsedWidth="0"
            style={{
              background: token.sidebar_background,
              borderRight: "1px solid #DADEE5",
            }}
            width={token.sidebar__width}
          >
            <Flex
              align="center"
              justify="space-between"
              style={{ height: "100%", padding: 16 }}
              vertical
            >
              <MenuSidebar items={sidebarItems} userEmail={state._id} />

              {state.personalInfo && <MenuProfile />}
            </Flex>
          </Layout.Sider>
          <Layout.Content style={{ background: "#fff", overflow: "auto" }}>
            {children}
          </Layout.Content>
        </Layout>
      </Layout>

      <ModalConversationDetails
        onCancel={() => state.setKeyValue("conversationModal", false)}
        open={state.conversationModal}
      />
      <ModalManagerSettings
        onCancel={() => state.setKeyValue("openModalManagerSettings", false)}
        open={state.openModalManagerSettings}
      />
      <SectionAskAdvice state={state} setState={setState} />
    </ConfigProvider>
  );
};

export default TemplateSuperAdminAuthorized;
